export const environment = {
  firebaseConfig: {
    apiKey: 'AIzaSyBWaYlUpX5ro-5JFu7WeCdPDru6wMelszM',
    authDomain: 'dysi-553d1.firebaseapp.com',
    projectId: 'dysi-553d1',
    storageBucket: 'dysi-553d1.firebasestorage.app',
    messagingSenderId: '344179333498',
    appId: '1:344179333498:web:0b75c9eb3136621c65dec3',
    measurementId: 'G-YXTD511F07',
  },
  brevo: {
    apiKey: 'YOUR_BREVO_API_KEY',
    senderEmail: 'manirajmca.ac@gmail.com',
    senderName: 'DySi Tours',
  },
};
